import React from "react";
import Rbac from "../../../utils/Rbac";

import {isViewVisible} from "../../../utils/ViewSettings";
import PricetariffsView from "./components/PricetariffsView";

export const rbac = new Rbac({
  _rbac: {
    "admin": {
      write: true,
      editPricetariff: true,
    },
    "manager": {
      write: true,
      editPricetariff: true,
    },
    "booking-manager": {
      write: true,
      editPricetariff: true,
    },
    "manager-location": {
      write: false,
      editPricetariff: false,
    },
    "user": {
      write: false,
      editPricetariff: false,
    },
    "garage-staff": {
      write: false,
      editPricetariff: false,
    }
  }
});


export const PricetariffsPage = props => {
  let _view = typeof props.view === 'undefined' || props.view === null ? 'index' : props.view;
  let indexView = isViewVisible('pricetariffs','contingents') ? 'pricetariffs' : '';
  return (
      <>
        {(_view === 'pricetariffs' || (_view === 'index' && indexView === 'pricetariffs')) &&
            <PricetariffsView
                name={"pricetariffs"}
                addd={props.add}
                dispatch={props.dispatch}
                params={props.params}
                createAccessBar={props.createAccessBar}
                returnPath={props.returnPath}
            />
        }
      </>
  );
};